import useSaveReservationInformation from "../../../../utils/hooks/useSaveReservationInformation";

const useSaveRegularReservationInformation = ({
	reservation, reservationState, 
	updateActivityPopup, 
	reservationType
}) => {
	const saveReservationInformationHandler = useSaveReservationInformation({
        reservation, reservationState, 
        updateActivityPopup, 
        reservationType
    });
	function responsibleHasAttended() {
		return reservation.students.responsible.attended;
    }
	return {
		...saveReservationInformationHandler,
		saveReservationInformation: () => {
			if (responsibleHasAttended()) {
				saveReservationInformationHandler.saveReservationInformation();
				return;
			}
			saveReservationInformationHandler.dialogResponsibleNotAttended.open();
			saveReservationInformationHandler.dialogSaveInformationConfirmation.hide();
			updateActivityPopup.mustConfirm.set(false);
		}
	}
}	
	
export default useSaveRegularReservationInformation;